import styled from 'styled-components';
import SecondaryButton from '@carvana/showroom-forms/Button/Secondary';

export const GapCoverageCardWrapper = styled.div`
  max-width: 912px;
  background: #ffffff;
  border: 1px solid #d9dde9;
  box-sizing: border-box;
  box-shadow: 0px 2px 3px rgb(24 53 88 / 10%);
  border-radius: 8px;
  overflow: hidden;
  font-family: Brandon Text;
  margin: 0 auto;

  hr {
    border: 1px solid var(--cvna-color-grey-2);
    border-bottom-color: transparent;
    margin: 0;
  }
`;

export const GapCoverageInfo = styled.div`
  width: 100%;
  display: flex;

  flex-direction: column;
  align-items: flex-start;

  // @media (max-width: 580px) {
  //   flex-direction: column;
  //   align-items: flex-start;
  // }

  // @media (max-width: 380px) {
  //   max-width: 180px;
  // }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
  }
`;

export const GapCoverageInfoBody = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-right: 56px;
  }
`;

export const GapCoverageCardHeaderContainer = styled.div`
  max-width: 912px;
  padding: 20px 24px;
  display: flex;
  align-items: center;
`;

export const GapCoverageCardHeader = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: var(--cvna-color-blue-6);
`;

export const GapCoverageCardContentContainer = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #757989;
  padding: 0 24px 24px;
  display: flex;
`;

export const GapCoverageCardListItemContainer = styled.div`
  background-color: #f4f8fa;
  border-radius: 3px;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    max-width: 345px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    max-width: 380px;
  }

  ul {
    margin: 0;
    padding: 8px 16px 8px 28px;

    li {
      font-size: 14px;
      line-height: 20px;
      color: #6d7184;

      div {
        display: inline-block;
      }

      a {
        color: #00aed9;
        margin-left: 3px;
        @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
          margin-left: 0;
        }
        @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
          margin-left: 3px;
        }
      }
    }
  }
`;

export const GapCoverageAccessClaimLink = styled.span`
  text-decoration: none;
  color: #00aed9;
  margin-left: 3px;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    display: block;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    display: inline-block;
  }
`;

export const GapCoverageSubHeadingContainer = styled.div`
  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    padding-right 20px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    padding: initial;
  }
`;

export const GapCoverageCardIconContainer = styled.div`
  padding-right: 16px;
  display: flex;
`;

export const GapCoverageSubHeading = styled.p`
  font-size: 16px;
  line-height: 20px;
  color: var(--cvna-color-blue-6);
  font-weight: 700;
  padding-bottom: 8px;
  margin: 0;
`;

export const GapCoverageSubText = styled.p`
  font-size: 14px;
  line-height: 20px;
`;

export const GapCoverageClaimLinksContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const GapCoverageButton = styled(SecondaryButton)`
  padding: 0 24px;
  margin: 0;
  min-height: 40px;
  word-break: break-word;
  min-width: auto !important;
  width: 100%;
  margin-top: 24px !important;

  @media (max-width: 600px) {
    min-width: 175px;
  }

  @media (max-width: 580px) {
    min-width: 250px;
  }

  @media (max-width: 380px) {
    min-width: 180px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    min-width: 200px !important;
    margin-top: 0;
    width: auto;
  }
`;

export const GapCoverageTelephoneLink = styled.a`
  @media (max-width: 690px) {
    display: block;
  }
`;
